// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__pDuKI"};